import { random_string } from "./random_string";
function linkCSS(urls){
    urls.map(( url )=>{
        var head  = document.getElementsByTagName('head')[0];
        var link  = document.createElement('link');
        link.id   = "css--exported-"+random_string(6);
        link.rel  = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        link.media = 'all';
        head.appendChild(link);
    })
}

export {linkCSS};